module.exports = __webpack_public_path__ + "media/images/inst-white-icon-0af10be2a0d9017c7469c56cb9e7ee15.png";